import { useLiveQuery } from '@sanity/preview-kit';
import { FC } from 'react';

import { BlogPostInterface } from '@/src/assets/interfaces/blogPostInterface';
import { getBlogPostDataQuery } from '@/src/assets/queries/blogPostDataQuery';

import { Post } from '../../screens/Post/Post';

interface PreviewPostPageProps {
    data: BlogPostInterface;
    slug: string;
}

const PreviewPostPage: FC<PreviewPostPageProps> = ({ data, slug }) => {
    const [blogPostData] = useLiveQuery(data, getBlogPostDataQuery(slug));

    return <Post post={blogPostData} />;
};

export { PreviewPostPage };
